import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { addPublicUserAccounts } from 'src/app/state/actions/public-user-account.actions';
import { AppState } from 'src/app/app.state';
import { PublicAccountSubmission } from 'src/app/modules/shared/model/publicAccountSubmission.model';
import { GFilterViewIdRepo, GFilterViewPermissionLevel } from 'src/app/repo/GFilterViewIds.repo';
import { MessageService, SelectItem } from 'primeng/api';
import { RecaptchaSettings } from 'src/app/modules/shared/model/recaptchaSettings.model';
import { takeUntil } from 'rxjs/operators';
import { AccelaControl, AccelaControlType } from 'src/app/modules/shared/model/accelaControl.model';
import { LocalizationService } from 'src/app/modules/shared/services/localization.service';
import { FieldMatch } from 'src/app/validators/fieldmatch.validator';
import { selectAppSettings } from 'src/app/state/selectors/app-settings.selectors';
import { Subject } from 'rxjs';
import { NavigationService } from 'src/app/modules/shared/services/navigation-service.service';
import { PageLayoutService } from 'src/app/modules/shared/services/page-layout.service';
import { SettingService } from 'src/app/modules/shared/services/setting.service';
import { selectAccountSubmission } from 'src/app/state/selectors/public-user-account.selectors';
import { CustomScriptInjectionService } from 'src/app/modules/shared/services/custom-script-injection.service';
import { QuestionModel } from 'src/app/modules/shared/model/questionModel.model';
@Component({
  selector: 'aca-register-screen',
  templateUrl: './register-screen.component.html',
  styleUrls: ['./register-screen.component.css']
})
export class RegisterScreenComponent implements OnInit, OnDestroy {

  receieveSMS: boolean;

  AccountForm: UntypedFormGroup;
  controlModelMap: Map<string, string>;
  simpleViewElements: AccelaControl[];
  module = '';
  viewId = GFilterViewIdRepo.UserRegistration;
  RecaptchaInfo: RecaptchaSettings;
  SectionKey = 'Sign Up';
  recaptchaLoaded = false;
  recaptchaVerified = false;
  disclaimerAccepted = false;
  Account: PublicAccountSubmission;
  adminMode: boolean;
  checkBxLabelText = $localize`I agree to the` ;
  currentStep = 1;
  maxStep = 2;
  defaultphonerequired = false;
  stepLogicLoaded = false;
  licRequired = false;
  securityQuestionsQuantity: number;
  securityQuestionsRequired = false;
  protected destroyActions = new Subject<boolean>();
  constructor(private store: Store<AppState>, private pageLayoutService: PageLayoutService, private router: Router,
    private formBuilder: FormBuilder, private settingService: SettingService,private localizationService: LocalizationService,
    private messageService: MessageService, protected navigationService: NavigationService, private renderer: Renderer2,
    private customScriptService: CustomScriptInjectionService) { 
      this.AccountForm = this.formBuilder.group({});
    }

  ngOnInit(): void {
    this.createRegistrationControlMap();
    this.store.select(selectAppSettings)
      .pipe(takeUntil(this.destroyActions))
      .subscribe({
        next: state => {
          this.adminMode = state.AdminMode;
          if(state.licenseRequiredForRegistration){
            this.currentStep+=1;
            this.maxStep+=1;
          }
          this.settingService.isEnableCustomizationPerPage()
          .pipe(takeUntil(this.destroyActions))
          .subscribe(res => {
            if(res){
              this.customScriptService.loadAndRunCustomScriptBlock(this.renderer, document, 'account_new');
            }
        });
          this.licRequired = state.licenseRequiredForRegistration;
          this.stepLogicLoaded = true;

          this.AccountForm = this.formBuilder.group({});
          if(!this.adminMode){
            this.store.select(selectAccountSubmission)
              .pipe(takeUntil(this.destroyActions))
              .subscribe((account) => {
                if(Object.hasOwnProperty.call(account,'PublicUserAccount')){
                  const submission =
                    JSON.parse(JSON.stringify((account as any).PublicUserAccount)); //deep copy as the object cmoming out is immutable
                  this.Account = submission;
                } else {
                  this.Account = new PublicAccountSubmission();
                }
                this.settingService.getLoginSettings()
                  .pipe(takeUntil(this.destroyActions))
                  .subscribe(res => {
                    this.securityQuestionsQuantity = res.CompulsoryQuantity;
                    this.securityQuestionsRequired = res.Enable;
                    this.addForm();
                  });
              });
          }
        }
      });

    this.settingService.getRecaptchaSettings()
      .pipe(takeUntil(this.destroyActions))
      .subscribe(res => {
        this.RecaptchaInfo = res;
      }
      , error => {
        this.messageService.add({
          severity: 'error',
          summary: error,
          closable: false
        });
      }      );
    this.localizationService.getLabelByKey('acc_registerStart_label_enterAccountInfo')
      .pipe(takeUntil(this.destroyActions))
      .subscribe((resp => {
        this.SectionKey = resp;
    }));

    this.localizationService.getLabelByKey('acc_regHome_label_acceptTerms')
      .pipe(takeUntil(this.destroyActions))
      .subscribe((resp => {
        this.checkBxLabelText = resp;
    }));
    this.renderReCaptcha(this);
  }

  addForm() {
    this.pageLayoutService
      .getDynamicFormData(this.viewId, this.module, GFilterViewPermissionLevel.UserRegistration, '', 'anonymous')
      .pipe(takeUntil(this.destroyActions))
      .subscribe((resp => {
        this.simpleViewElements = resp;
        
        if (this.securityQuestionsRequired && this.securityQuestionsQuantity > 1) {

          const ddlQuestionControlData = this.simpleViewElements.find(questionControl => questionControl.name === 'ddlQuestion');
          const txbAnswerControl = this.simpleViewElements.find(ansControl => ansControl.name === 'txbAnswer');
          const txbAnswerControlindex = this.simpleViewElements.findIndex(ansControsl => ansControsl.name === 'txbAnswer');

          for (var i = this.securityQuestionsQuantity; i >= 1; i--) {

            const closedQuestion = Object.assign({}, ddlQuestionControlData);
            const clonedAns = Object.assign({}, txbAnswerControl);

            clonedAns.name = clonedAns.name + i.toString();
            clonedAns.label = clonedAns.label + ' ' + i.toString();
            this.simpleViewElements.splice(txbAnswerControlindex, 0, clonedAns);

            closedQuestion.name = closedQuestion.name + i.toString();
            closedQuestion.label = closedQuestion.label + ' ' + i.toString();
            this.simpleViewElements.splice(txbAnswerControlindex, 0, closedQuestion);

          }

          const questioncntrlindex = this.simpleViewElements.findIndex(ansControsl => ansControsl.name === 'ddlQuestion');
          this.simpleViewElements.splice(questioncntrlindex, 1);
          const anscntrlindex = this.simpleViewElements.findIndex(ansControsl => ansControsl.name === 'txbAnswer');
          this.simpleViewElements.splice(anscntrlindex, 1);
        }
        


        this.simpleViewElements.forEach(controlData => {

          if (controlData.display) {
            const abstractControl = new UntypedFormControl(controlData.value);

            this.pageLayoutService.processAccelaControl(controlData, abstractControl);
            if(this.Account){
              abstractControl.patchValue(this.Account[this.controlModelMap.get(controlData.name)]);
            }
            this.AccountForm.addControl(controlData.name, abstractControl);
            if (controlData.name === 'txbMobilePhone') {
              if (controlData.required) {
                this.defaultphonerequired = true;
              }
            }
            if (controlData.name === 'cbReceiveSMS' && abstractControl.value === true) {
              this.validateReqSMSCheckbox(true);
            }
          }

        });
        if (this.AccountForm.validator) {
          this.AccountForm.setValidators([this.AccountForm.validator, FieldMatch('txbPassword1', 'txbPassword2')]);
        } else { /* if no validators added already */
          this.AccountForm.setValidators([FieldMatch('txbPassword1', 'txbPassword2')]);
        }
      })
      , error => {
        this.messageService.add({
          severity: 'error',
          summary: error,
          closable: false
        });
      }      );
  }

  createRegistrationControlMap() {

    this.controlModelMap = new Map<string, string>();
    this.controlModelMap.set('txbUserName', 'Username');
    this.controlModelMap.set('txbEmail', 'Email');
    this.controlModelMap.set('txbPassword1', 'Password');
    this.controlModelMap.set('txbPassword2', 'Password');
    this.controlModelMap.set('ddlQuestion', 'SecurityQuestion');
    this.controlModelMap.set('txbAnswer', 'SecurityAnswer');
    this.controlModelMap.set('txbMobilePhone', 'PhoneNumber');
    this.controlModelMap.set('cbReceiveSMS', 'PermissionToSendSMSMsgs');


  }

  renderReCaptcha(ref): void {
    if (this.RecaptchaInfo && !this.RecaptchaInfo.IsCaptchaEnabledForLogin) {
      this.recaptchaLoaded = true;
      return;
    }

    if (!this.RecaptchaInfo || !(window as any).grecaptcha || !(window as any).grecaptcha.render) {
      setTimeout(()=> {
        ref.renderReCaptcha(ref);
      }, 500);

    } else {
      this.recaptchaLoaded = true;
      return;
    }
  }

  getStepText() {
    return this.stepLogicLoaded
      ? `Step ${this.currentStep} of ${this.maxStep}: Account Details`
      : ``;
  }

  updateRecaptchaStatus(result: boolean): void {
    this.recaptchaVerified = result;
    if (result) {
      const box = document.getElementById('captcha');
      box.style.setProperty('border', 'none');
    }
  }

  back() {
    if (this.adminMode) {
      return;
    }
    if(this.licRequired){
      this.navigationService.navigateRoute('account/register-declare-license');
    } else {
      this.navigationService.navigateLegacyPage(this.navigationService.getHomePageUrl());
    }
  }

  submitRegistration(formData) {
    if (this.adminMode) {
      return;
    }
    
    this.AccountForm.markAllAsTouched();
    this.AccountForm.markAsDirty();
    this.AccountForm.updateValueAndValidity();
    this.messageService.clear();

    if (this.RecaptchaInfo.IsCaptchaEnabledForRegistration && !this.recaptchaVerified) {
      this.messageService.clear();
      const box = document.getElementById('captcha');
      box.style.setProperty('border', '1px solid red');
      this.messageService.add({
        severity: 'error',
        summary: $localize`Please fill out the Recaptcha properly before submitting again.`,
        closable: false
      });
      return;
    }

    // Validate form
    let valid = true;
      for (const simpleElemName in this.AccountForm.controls) {
          const formControl = this.AccountForm.controls[simpleElemName] as UntypedFormControl;
          if(formControl.validator){
            formControl.markAsDirty();
          }
          if (formControl.errors && Object.keys(formControl.errors).length > 0) {
            valid = false;
          }
    }
    if (!this.disclaimerAccepted) {
      valid = false;
    }

    if (!valid) {
      this.messageService.clear();
      this.messageService.add({
        severity: 'error',
        summary: $localize`Not all fields are filled out correctly. Please check again.`,
        closable: false
      });
      return;
    }


    const submission = new PublicAccountSubmission();
    submission.Username = formData['txbUserName'];
    submission.Email = formData['txbEmail'];
    submission.Password = formData['txbPassword1'];
    submission.PhoneNumber = formData['txbMobilePhone'];
    submission.PermissionToSendSMSMsgs = formData['cbReceiveSMS'];
    submission.licenseLinks = this.Account.licenseLinks;
    submission.Questions = new Array<QuestionModel>();
    for (var i = 1; i <= this.securityQuestionsQuantity; i++) {
      var qusModel = new QuestionModel();
      if (this.securityQuestionsQuantity === 1) {
        qusModel.questionValueField = formData['ddlQuestion'];
        qusModel.answerValueField = formData['txbAnswer'];
      }
      else {
        qusModel.questionValueField = formData['ddlQuestion' + i.toString()];
        qusModel.answerValueField = formData['txbAnswer' + i.toString()];
      }
      qusModel.recFulNameField = 'ADMIN';
      submission.Questions.push(qusModel);     
    }  
    
    this.store.dispatch(addPublicUserAccounts({PublicUserAccount: submission}));

    this.router.navigate(['account', 'register-contact-detail']);
  }

  validateReqSMSCheckbox(chkstatus: boolean) {
    if (!this.defaultphonerequired) {
      this.AccountForm.controls['txbMobilePhone'].controlData.required = chkstatus;
    }
  }

  navigateToDisclaimer(): void {
    if (!this.adminMode) {
      this.navigationService.navigateNewTab('AngularUI/CommunityView/account/register-termsofuse', 'newAdmin');
    }
  }

  ngOnDestroy(): void {
    this.customScriptService.removeTrackedElements();
    this.destroyActions.next(null);
    this.destroyActions.complete();
  }


}
